//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ImportColumnInputItem } from './ImportColumnInputItem';
import { TeacherImportColumn } from './Enums';

export class TeacherImportColumnInputItem extends ImportColumnInputItem {
    Column: TeacherImportColumn = TeacherImportColumn.FirstName;

    constructor(initializer?: Partial<TeacherImportColumnInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "TeacherImportColumnInputItem";
}
